import { render, staticRenderFns } from "./WordDrumForm.vue?vue&type=template&id=70463178&scoped=true&lang=pug&"
import script from "./WordDrumForm.vue?vue&type=script&lang=js&"
export * from "./WordDrumForm.vue?vue&type=script&lang=js&"
import style0 from "./WordDrumForm.vue?vue&type=style&index=0&id=70463178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70463178",
  null
  
)

export default component.exports